import { Participant, PercentBasedChallengeData } from '../types/participant';

export function hasParticipantFailedPercentBasedChallenge(participant: Participant): boolean {
  return !!participant.challengeData.expenseAmount
    && participant.challengeData.expenseAmount
    > (participant.challengeData as PercentBasedChallengeData).challengeGoal;
}
export function hasParticipantFailedValueBasedChallenge(participant: Participant, challengeGoal: number): boolean {
  return !!participant.challengeData.expenseAmount
  && participant.challengeData.expenseAmount > challengeGoal;
}
